module.exports = __webpack_public_path__ + "static/img/bg-2.9e4b640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-2.png
// module id = z+qV
// module chunks = 0